import MuiGrid, {GridProps} from '@mui/material/Grid';

export const Grid = (props: GridProps) => {
    return <MuiGrid {...props} />
}